import { render, staticRenderFns } from "./QualityJudgmentList.vue?vue&type=template&id=4c8529fb"
import script from "./QualityJudgmentList.vue?vue&type=script&lang=js"
export * from "./QualityJudgmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports